import { AdditionalHeader, ApiVersion, Authentication, BaseRequest } from './baseRequest';
import * as t from 'io-ts';

/**
 * Base class for all GET requests.
 */
export class BaseGetRequest<T> extends BaseRequest<T> {
    constructor(
        relativeUrl: string,
        queryStringParameters: {[key: string]: string},
        resultDynamicType: t.Type<T>,
        authenticationRequired: Authentication = Authentication.Login,
        apiVersion: ApiVersion = 'v1'
    ) {
        super(relativeUrl, queryStringParameters, resultDynamicType, authenticationRequired, apiVersion);
    }

    protected buildRequestInit(additionalHeaders: AdditionalHeader[]): RequestInit {
        return {
            ...super.buildRequestInit(additionalHeaders),
            method: 'GET'
        };
    }
}
